import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "wrapper" }
const _hoisted_2 = {
  key: 0,
  id: "important",
  class: "very-important"
}
const _hoisted_3 = { id: "important" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_6 = { id: "urls" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Verzije")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Autor")
const _hoisted_9 = { id: "heading" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  id: "ed",
  class: "ed"
}, "e-Dnevnik", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", {
  id: "plus",
  class: "plus"
}, "Plus", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { id: "subtitle" }, "Proširenje za školski e-Dnevnik", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { style: {"color":"gray"} }, " Ovo proširenje nije službena CARNET-ova aplikacija. ", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("a", {
  class: "plus",
  href: "mailto:kristijan.ros@gmail.com?subject=e-Dnevnik Plus — Kontakt"
}, " kristijan.ros@gmail.com", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_16 = /*#__PURE__*/_createVNode("a", {
  class: "plus",
  href: "https://k1k1.dev/",
  target: "_blank"
}, "k1k1.dev", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" politika privatnosti")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.importantMessage)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("span", { innerHTML: _ctx.importantMessage }, null, 8, ["innerHTML"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      (_ctx.$inApp)
        ? (_openBlock(), _createBlock("strong", _hoisted_4, " Tvoja trenutno instalirana verzija proširenja: " + _toDisplayString(_ctx.$lastVersion), 1))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode(_Transition, { name: "opacity" }, {
              default: _withCtx(() => [
                (_ctx.message)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      innerHTML: _ctx.message
                    }, null, 8, ["innerHTML"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _hoisted_5
          ], 64)),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, { to: "/povijest" }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/autor" }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, {
        to: "/",
        id: "title"
      }, {
        default: _withCtx(() => [
          _hoisted_10,
          _hoisted_11
        ]),
        _: 1
      }),
      _hoisted_12
    ]),
    _createVNode(_component_router_view, { class: "router-view" }),
    _createVNode(_Transition, { name: "opacity" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode("div", {
          id: "footer",
          class: { default: _ctx.$route.path != '/' }
        }, [
          _hoisted_13,
          _createTextVNode(" 2019.-" + _toDisplayString(new Date().getFullYear()) + ". | ", 1),
          _hoisted_14,
          _hoisted_15,
          _hoisted_16,
          _hoisted_17,
          _createVNode(_component_router_link, {
            to: "politika-privatnosti",
            class: "plus"
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          })
        ], 2), [
          [_vShow, _ctx.$route.path != '/' || _ctx.scrollTop == 0 || _ctx.$isMobile]
        ])
      ]),
      _: 1
    })
  ]))
}